export default __webpack_public_path__ + "media/images/69-ec3c9d943f2e3e766b7879b9454c24ab.jpg";